import React from "react";

import { Route, Redirect } from "react-router-dom";
import { isAuthenticated } from "../services/auth";
import { connect } from "react-redux";

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() === true ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: localStorage.getItem('role') ? "/admin/receivables" : "/",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);
const mapStateToProps = (state) => ({
  role: state.user.role,
});

export default connect(mapStateToProps)(ProtectedRoute);
